<template>
  <div>
    <backButton></backButton>
    MarketplacePage
  </div>
</template>
<script>
import backButton from "../components/backButton.vue";
export default {
  components: {
    backButton,
  },
  methods: {},
};
</script>
<style lang="scss"></style>
